import React, { createRef } from 'react';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClickOutside: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
};
// eslint-disable-next-line import/no-default-export
export default class ClickOutside extends React.PureComponent<Props> {
  isTouch = false;

  containerRef = createRef<HTMLDivElement>();

  componentDidMount() {
    document.addEventListener('touchend', this.handle, true);
    document.addEventListener('click', this.handle, true);
  }

  componentWillUnmount() {
    document.removeEventListener('touchend', this.handle, true);
    document.removeEventListener('click', this.handle, true);
  }

  handle = (e: TouchEvent | MouseEvent) => {
    if (e.type === 'touchend') this.isTouch = true;
    if (e.type === 'click' && this.isTouch) return;
    const { onClickOutside } = this.props;
    const el = this.containerRef.current;
    if (el && e.target instanceof Node && !el.contains(e.target))
      onClickOutside(e);
  };

  render() {
    const { children, onClickOutside, ...props } = this.props;
    return (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/jsx-props-no-spreading
      <div {...props} ref={this.containerRef}>
        {children}
      </div>
    );
  }
}
